import axios from 'axios'
import { CATALOGO_ENDPOINT } from '../../endpoints'
import { BFFAgent } from 'BFFAgent'
import { encodeImageUrl } from 'Utilities'
import { CAR_NOT_FOUND_THUMB } from '../../assets'

export const sanitizeData = auto => {
    // because sometimes the numbers come as strings and that causes bugs
    auto.precio_lista = Number(auto.precio_lista)
    auto.bonificacion = Number(auto.bonificacion)
    auto.flete_alistaje = Number(auto.flete_alistaje)
    if (auto.precio_final) {
        auto.precio_final = Number(auto.precio_final)
    }
    if (auto.accessory_1) {
        auto.accessory_1 = Number(auto.accessory_1)
    }
    if (auto.accessory_2) {
        auto.accessory_2 = Number(auto.accessory_2)
    }
    return auto
}

export const setBottomRightInfo = auto => {
    auto.bottomRightInfo = [auto.nuevo ? '0km' : auto.año, auto.COMBU]
        .filter(e => e)
        .join(' - ')
        .toLowerCase()
    return auto
}

export async function getAuto(id, queryString) {
    try {
        const auto = await axios(`${CATALOGO_ENDPOINT}/${id}?${queryString}`)
            .then(res => res.data.data)
            .then(sanitizeData)
        auto.title = `${auto.brand} ${auto.model} ${auto.version}`
        auto.currency = await BFFAgent.Datamasters.getCurrency(auto.exchange_rate_id, null)
        return auto
    } catch (error) {
        throw new Error(error)
    }
}

export async function getAutoVistaVendedor(id) {
    return getAuto(id, '')
}

export async function getAutoFull(id, queryString) {
    const [auto, fileAssociations] = await Promise.all([
        axios(`${CATALOGO_ENDPOINT}/${id}?${queryString}`)
            .then(res => res.data.data)
            .then(sanitizeData),
        BFFAgent.Files.getFileAssociations({ id }, 'PRODUCTO').catch(err => err)
    ])

    // el error en files se agarra de manera independiente al Promise.all (ver el catch al final de linea)
    if (fileAssociations instanceof Error) {
        auto.fileAssociations = []
        auto.fileAssociationsError = fileAssociations
    } else {
        const thumbImage = fileAssociations.filter((file) => file.type.name.includes('image/'))[0]
        auto.thumbnail = thumbImage
            ? encodeImageUrl(`${thumbImage.url}`)
            : encodeImageUrl(`${CAR_NOT_FOUND_THUMB}`)
        auto.fileAssociations = fileAssociations
    }

    const [lineasFinancieras] = await Promise.all([
        BFFAgent.Simulador.getLineasFinancieras(auto).catch((err) => err)
    ])

    // el error en lineasFinancieras se agarra de manera independiente al Promise.all (ver el catch al final de linea)
    if (lineasFinancieras instanceof Error) {
        auto.lineasFinancieras = []
        auto.lineasFinancierasError = lineasFinancieras
    } else {
        auto.lineasFinancieras = lineasFinancieras
    }

    return auto
}

export async function getCarByCatalogidAndCarlotid(catalogId, carlotId) {
    const { data: { data } } = await axios(`${CATALOGO_ENDPOINT}/${catalogId}?car_lot_id=${carlotId}`)
    return data
}

export async function getCatalogId(id, car_lot_id) {
    try {
        const { data: { data } } = await axios(`${CATALOGO_ENDPOINT}/${id}?${car_lot_id}`)
        return data
    } catch (error) {
        throw new Error(error)
    }

}